import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SigninComponent } from './signin.component';
import { InputModule } from 'src/app/common/utilities/input/input/input.module';
import { ButtonFillModule } from 'src/app/common/utilities/buttons/button-fill/button-fill/button-fill.module';
import { ErrorMessageModule } from "../../common/components/error-message/error-message.module";
import { ToastModule } from 'primeng/toast';

@NgModule({
    declarations: [
        SigninComponent
    ],
    imports: [
        CommonModule,
        ButtonFillModule,
        ErrorMessageModule,
        ToastModule,
        InputModule,
    ]
})
export class SigninModule { }
